module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/trouble_img_01-094beb37335da4de156ab26b56faaa5c.jpg";